import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "frankly:myTriesBadge"

export default class extends Controller {
  static targets = ["icon", "label", "badge", "iconWrap"]
  static values = { current: Boolean }

  connect() {
    this._boundCelebrate = this.celebrate.bind(this)
    window.addEventListener("frankly:try-saved", this._boundCelebrate)

    if (this.currentValue) {
      sessionStorage.removeItem(STORAGE_KEY)
      this._hideBadge()
    } else if (sessionStorage.getItem(STORAGE_KEY)) {
      this._showBadge()
    }
  }

  disconnect() {
    window.removeEventListener("frankly:try-saved", this._boundCelebrate)
  }

  celebrate() {
    if (!this.currentValue) {
      sessionStorage.setItem(STORAGE_KEY, "1")
      this._showBadge()
    }

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (reducedMotion) return

    const icon = this.hasIconTarget ? this.iconTarget : null
    const label = this.hasLabelTarget ? this.labelTarget : null
    const iconWrap = this.hasIconWrapTarget ? this.iconWrapTarget : null

    if (icon) {
      icon.classList.remove("nav-fx-bounce", "nav-fx-glow")
      void icon.offsetWidth
      icon.classList.add("nav-fx-bounce", "nav-fx-glow")
      setTimeout(() => icon.classList.remove("nav-fx-bounce"), 600)
      setTimeout(() => icon.classList.remove("nav-fx-glow"), 1200)
    }

    if (label) {
      label.classList.remove("nav-fx-lightup")
      void label.offsetWidth
      label.classList.add("nav-fx-lightup")
      setTimeout(() => label.classList.remove("nav-fx-lightup"), 1200)
    }

    if (iconWrap) {
      const ring = document.createElement("div")
      ring.className = "nav-fx-ring"
      iconWrap.appendChild(ring)
      setTimeout(() => ring.remove(), 700)
    }
  }

  _showBadge() {
    if (this.hasBadgeTarget) this.badgeTarget.classList.remove("hidden")
  }

  _hideBadge() {
    if (this.hasBadgeTarget) this.badgeTarget.classList.add("hidden")
  }
}
